<template>
     <div id="theme--tuktuk__product-details" :style="{ paddingBottom: data.embed || data.themeType=='TuktukStep1' ? '0': getNavigationBottomHeight() + 'px' }">
        <!-- PRODUCT IMAGE -->    
         
            <product-image v-if="data.showProductImages && data.productImages[0]" :productImageSetting="{enableNumber:true}" :images="data.productImages" :variantImageIndex="data.variantImageIndex" :autoSlideSettings="data.autoSlideSettings" />
        

        <div class="theme--tuktuk__product-details__info theme--tuktuk__card">
            <div class="theme--tuktuk__container">
                <!-- Product Price-->
                <section v-if="data.type == 'simple'" class="theme--tuktuk__product-details__price">
                    <template v-if="parseInt(data.priceCompare) !== parseInt(data.price) && data.priceCompare > 0">
                        <div>
                            <h2 class="theme--tuktuk__product-details__price__sales">
                                Rp{{ data.priceCompare | g_number_format }}
                            </h2>
                            <div v-if="percentageCal > 0" class="theme--tuktuk__label--pink">
                                {{ $t("tuktukTheme.saveUpTo") }} {{ percentageCal }}%
                            </div>
                        </div>
                        <div class="theme--tuktuk__product-details__price__container-sales">
                            <p class="theme--tuktuk__product-details__price__regular">
                                <template v-if="data.price">
                                    Rp{{ (data.price) | g_number_format }}
                                </template>
                            </p>
                        </div>
                    </template>
                    <template v-else>
                        <h2 class="theme--tuktuk__product-details__price__regular">
                            Rp{{ data.price | g_number_format }}
                        </h2>

                    </template>

                </section>
                <section v-else class="theme--tuktuk__product-details__price">
                    <template v-if="variant.lowestSalePrice &&
                        variant.lowestSalePrice > 0 &&
                        variant.highestSalePrice != -Infinity">
                        <div>
                            <h2 class="theme--tuktuk__product-details__price__sales">
                                <template v-if="variant.highestSalePrice > 0 && parseInt(variant.lowestSalePrice) !== parseInt(variant.highestSalePrice)">
                                    Rp{{ variant.lowestSalePrice | g_number_format }} - Rp{{ variant.highestSalePrice | g_number_format }}
                                </template>
                                <template v-else>
                                    Rp{{ variant.highestSalePrice | g_number_format }}
                                </template>
                            </h2>
                            <div v-if="percentageCal > 0" class="theme--tuktuk__label--pink">
                                {{ $t("tuktukTheme.saveUpTo") }} {{ percentageCal }}%
                            </div>
                        </div>
                        <div class="theme--tuktuk__product-details__price__container-sales">
                            <p class="theme--tuktuk__product-details__price__regular">
                                Rp{{ variant.highestRegularPrice | g_number_format }}
                            </p>
                        </div>
                    </template>
                    <template v-else>
                        <h2 class="theme--tuktuk__product-details__price__regular">
                            <template v-if="variant.highestRegularPrice > 0 &&
                                parseInt(variant.lowestRegularPrice) !==
                                parseInt(variant.highestRegularPrice)">
                                Rp{{ variant.lowestRegularPrice | g_number_format }} - Rp{{ variant.highestRegularPrice |
                                    g_number_format }}

                            </template>
                            <template v-else>
                                Rp{{ variant.highestRegularPrice | g_number_format }}
                            </template>
                        </h2>
                    </template>                  

                </section>

                <!-- Product Name-->
                <h1 class="theme--tuktuk__title"
                    v-if="data.tuktukThemeSetting && data.tuktukThemeSetting.isCheckoutNameAsProduct">
                    {{ data.pageName }}
                </h1>
                <h1 class="theme--tuktuk__title" v-else>
                    {{ data.name }}
                </h1>

                <!-- Rating Section-->
                <section v-if="data.tuktukThemeSetting && data.showRatingItemSold"
                    class="theme--tuktuk__product-details__statistic">
                    <div v-if="data.tuktukThemeSetting.currentRatingValue" class="theme--tuktuk__product-details__statistic__rating">
                        <svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.29684 2.56906C7.57474 1.94378 8.42546 1.94378 8.70336 2.56906L10.0152 5.52075C10.1282 5.77497 10.3589 5.95011 10.6252 5.98383L13.7171 6.3754C14.372 6.45835 14.6349 7.30379 14.1517 7.77319L11.8706 9.989C11.6741 10.1798 11.586 10.4632 11.6376 10.7383L12.2366 13.932C12.3635 14.6085 11.6753 15.131 11.0987 14.7959L8.37708 13.2136C8.14268 13.0773 7.85752 13.0773 7.62312 13.2136L4.90146 14.7958C4.3249 15.131 3.63665 14.6085 3.76356 13.932L4.36262 10.7383C4.41421 10.4632 4.32609 10.1798 4.12963 9.989L1.8485 7.77319C1.36526 7.30379 1.62815 6.45835 2.28314 6.3754L5.37503 5.98383C5.64132 5.95011 5.87202 5.77497 5.985 5.52075L7.29684 2.56906Z" 
                            :fill="data.tuktukThemeSetting.ratingColor ? data.tuktukThemeSetting.ratingColor : '#F6D14B'" />
                        </svg>
                        <p v-if="data.tuktukThemeSetting.currentRatingValue || data.tuktukThemeSetting.numberOfUsers">
                            <template v-if="data.tuktukThemeSetting.currentRatingValue">
                                {{ currentRatingNormalized }}/{{ maxRatingValueNormalized}}
                            </template>
                            <span v-if="data.tuktukThemeSetting.numberOfUsers">
                                ({{ data.tuktukThemeSetting.numberOfUsers}})
                            </span>
                        </p>
                    </div>
                    <div v-if="data.tuktukThemeSetting.itemSoldAmount" style="height: 20px; width: 0.5px; background-color: #6C7E95;"></div>
                    <div v-if="data.tuktukThemeSetting.itemSoldAmount" class="theme--tuktuk__product-details__statistic__rating">
                        <svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4912 14.5C12.4022 14.5 13.177 13.8518 13.3155 12.9737L13.9781 8.7737C14.1502 7.68334 13.2851 6.7 12.1538 6.7H9.99844C9.65864 6.7 9.38317 6.43137 9.38317 6.1V3.9795C9.38317 3.1624 8.70393 2.5 7.86603 2.5C7.66618 2.5 7.48507 2.61478 7.4039 2.79287L5.23871 7.54368C5.13996 7.76036 4.91962 7.9 4.67648 7.9H4.5V14.5H11.4912ZM3.5 14.5V7.9H3.23053C2.55093 7.9 2 8.43726 2 9.1V13.3C2 13.9627 2.55093 14.5 3.23053 14.5H3.5Z" fill="#F6D14B"/>
                            <path d="M7 9.57692L8.61538 11.1923L11.3077 8.5" stroke="white"/>
                        </svg>
                        <p v-if="data.tuktukThemeSetting.itemSoldAmount"
                            class="theme--tuktuk__product-details__statistic__sold">
                            {{ data.tuktukThemeSetting.itemSoldAmount | g_number_format }} <span> {{ $t("tuktukTheme.sold") }}</span>
                        </p>
                    </div>
                </section>
                <Seal :data="{ ...data }" v-if="data.showSeals && data.sealText && data.sealText.length > 0" />
            </div>
        </div>

        <!-- Sold Product -->
        <sold-product-component
            v-if="data.showSoldProduct"
            theme="tuktuk"
            :config="{ ...data.soldProductSetting }"
            style="margin-bottom: 8px;"
        />

        <!--SelectOptions -->
       
        <SelectOptions v-if="data.showProductVariant" @updateCartQuantity="updateCartQuantity" :data="{ ...data }" :payload="data.payload" @addCartItem="addCartItem"
            @addToCart="addToCart" @showMsg="showMsg" :isVariantModalOpen="isVariantModalOpen" @setStep="setStep" @changeVariant="changeVariant" @updateCartSummary="updateCartSummary" />
      
        <!-- Coupon -->
        <Coupon v-if="data.themeType=='TuktukStep1' && data.showCoupon" :data="{ ...data }" @updateDiscountLists="updateDiscountLists"  @applyDiscount="applyDiscount" @clearDiscount="clearDiscount"  />
        

        <!-- REVIEWS-->
        <div id="Reviews" ref="Reviews"></div>
        <div class="theme--tuktuk__product-details__testimoni theme--tuktuk__card"
            v-if="data.testimonials.length && data.showTestimonials">
            <Bottom :data="data" />
        </div>


        <div v-if="data.showVideo && videoUrl != '' || data.showContentBullet || data.showBumpProductStep1"
            class="theme--tuktuk__product-details__others theme--tuktuk__card">
            <div id="Description" ref="Description"></div>
            <div class="theme--tuktuk__product-details__others__title">
                <p>{{ $t("tuktukTheme.aboutThisProduct") }}</p>
            </div>

            <!-- YOUTUBE -->
            <div v-if="data.showVideo && videoUrl != ''" class="theme--tuktuk__product-details__others__video">
                <!-- <iframe :src="'https://www.youtube.com/embed/' + videoUrl" allowfullscreen></iframe> -->               
                <YouTubeVideo :videoId="videoUrl.trim()"/>
            </div>

            <!-- DESCRIPTION and BULLETS -->
            <div v-if="data.showContentBullet" class="theme--tuktuk__container flex flex-column">
                <!-- DESCRIPTION -->
                <div v-if="data.content" class="theme--tuktuk__product-details__others__description" v-html="data.content">
                </div>
                <!-- BULLETS -->
                <div v-if="data.bullets.length" class="theme--tuktuk__product-details__others__bullet">
                    <div v-html="data.titleBullet" class="theme--tuktuk__sub-title"></div>
                    <div class="theme--tuktuk__product-details__others__bullet__list">
                        <div :key="bullet.name" v-for="(bullet, index) in data.bullets"
                            class="theme--tuktuk__product-details__others__bullet__list__item">
                            <img :alt="'bullet-' + index" src="@/assets/icons/TuktukTheme/checklist--pink.svg" />
                            <p>{{ bullet.name }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bump order step 1-->
            <div v-if="data.showBumpProductStep1" class="theme--tuktuk__container">
                <BumpOrder :data="{ ...data }" />
            </div>
        </div>



        <!--Buy Now -->
        <BuyNow @setStep="setStep" :data="{ ...data,isVariantModalOpen }" @openVariantModal="openVariantModal" @updateCartQuantity="updateCartQuantity" @updateCartSummary="updateCartSummary" @changeVariant="changeVariant" :showCaptcha="showCaptcha" />
    </div>
</template>
<script>
import { getYoutubeVideoId } from "@/helpers/youtube";
import Bottom from "./../../bottom.vue";
import config from "./../../../../config.js";
import BuyNow from "./BuyNow.vue";
import SelectOptions from "./SelectOptions.vue";
import Seal from "./Seal.vue";
import BumpOrder from "./../Checkout/BumpOrder.vue";
import ProductImage from "../../../ProductImage.vue";
import { getSizedImageUrl } from "@/helpers/imagekitHelper";
import Coupon from "./Coupon.vue";
import YouTubeVideo from "../../../YouTubeVideo.vue";
import { SoldProductComponent } from '@formulir/components-checkout'

export default {
    props: ["data", "cartQuantity", "showCaptcha"],
    data() {
        return {
            baseUrl: config.api.replace("/api", ""),
            videoUrl: "",
            percentageCal: 0,
            isVariantModalOpen: false,
            variant: {
                lowestSalePrice: 0,
                highestSalePrice: 0,
                highestRegularPrice: 0,
                lowestRegularPrice: 0
            },
            getSizedImageUrl,
            isMobile:(this.data.nuxt2 && process.client) || !this.data.nuxt2 ? window.innerWidth < 575 : false,
        };
    },
    components: {
        Bottom,
        BuyNow,
        SelectOptions,
        Seal,
        BumpOrder,
        ProductImage,
        Coupon,
        YouTubeVideo,
        SoldProductComponent
    },
    watch: {
        "data.componentVideo"() {
            this.getVideoId();
        },
        "data.changeVariant": {
      handler(val) {        
        this.isVariantModalOpen=val;      
       // this.$emit("changeVariant", val);
      }
    }, 
    },
    filters: {
        g_number_format(val) {
            return new Intl.NumberFormat().format(val);
        },
    },
    mounted() {
       
        this.$nextTick(() => {
            if((this.data.nuxt2 && process.client) || !this.data.nuxt2){
                window.addEventListener('resize', this.onResize);
            }
            
        })
        this.getVideoId();
        if (this.data.type == "simple") {
            if (this.data.priceCompare > 0) {
                this.percentageCal = parseInt(
                    ((this.data.price - this.data.priceCompare) * 100) / this.data.price
                );
            }
        } else {

            let lowestSalePrice = Infinity;
            let highestSalePrice = -Infinity;
            let lowestRegularPrice = Infinity;
            let highestRegularPrice = -Infinity;

            this.data.variablePrices = this.data.variablePrices.map(item => {

                if (!item.delete) {
                    if (item.priceCompare && item.priceCompare > highestSalePrice) {
                        highestSalePrice = item.priceCompare
                    }

                    if (item.priceCompare && item.priceCompare < lowestSalePrice) {
                        lowestSalePrice = item.priceCompare
                    }

                    if (item.price > highestRegularPrice) {
                        highestRegularPrice = item.price
                    }


                    if (item.price < lowestRegularPrice) {
                        lowestRegularPrice = item.price
                    }
                    if (
                        item.priceCompare &&
                        item.priceCompare > 0
                    ) {
                        item['percentageCal'] = parseInt(
                            ((item.price -
                                item.priceCompare) *
                                100) /
                            item.price
                        );
                    } else {
                        item['percentageCal'] = 0;
                    }
                } else {
                    item['percentageCal'] = 0;
                }

                return item;

            })

            this.variant = {
                lowestSalePrice,
                highestSalePrice,
                highestRegularPrice,
                lowestRegularPrice
            };

            const maxSalePrice = this.data.variablePrices.reduce((max, item) => Math.max(max, item.percentageCal), -Infinity);

            if (
                maxSalePrice > 0
            ) {
                this.percentageCal = parseInt(maxSalePrice);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        updateDiscountLists(discounts,replace){           
            this.$emit('updateDiscountLists',discounts,replace)
        },
        applyDiscount(val) {
            this.$emit("applyDiscount", val);
        },
        clearDiscount(code) {
            this.$emit("clearDiscount", code);
        },
        onResize() {
            this.isMobile = window.innerWidth < 575;
        },
        setStep(count) {
            this.$emit("setStep", count);
        },
        changeVariant(val) {
            this.$emit("changeVariant", val);
        },
        addToCart() {
            this.$emit("addToCart");
        },
        showMsg() {
            this.$emit("showMsg");
        },
       
        updateCartQuantity(qty) {
            this.$emit("updateCartQuantity", qty);
        },
        addCartItem() {
            this.$emit("addCartItem");
        },
        updateCartSummary(index) {
            this.$emit("updateCartSummary", index);
        },
        getVideoId() {
            this.videoUrl = getYoutubeVideoId(this.data.componentVideo);
        },
        getNavigationBottomHeight(initHeight = 120) {
            if((this.data.nuxt2 && process.client) || !this.data.nuxt2){            
                const elementNavigationBottom = document.querySelector(".theme--tuktuk__navigation-bottom")
                if(elementNavigationBottom){
                    return elementNavigationBottom.clientHeight;
                }
            }
            return initHeight;
        },
        openVariantModal(val) {
            this.isVariantModalOpen = val;
        },
        handleRatingValue(rawValue) {
            const numericValue = Number(rawValue);

            return isNaN(numericValue) ? '-' : numericValue.toFixed(1);
        }
    },
    computed:{
        currentRatingNormalized() {
            const rawValue = this.data && this.data.tuktukThemeSetting ? this.data.tuktukThemeSetting.currentRatingValue : "-";

            return this.handleRatingValue(rawValue);
        },
        maxRatingValueNormalized() {
            const rawValue = this.data && this.data.tuktukThemeSetting ? this.data.tuktukThemeSetting.maxRatingValue : "-";

            return this.handleRatingValue(rawValue);
        }
    },
};
</script>
